export interface GetLayerDetailsParams {
  applicationId: string;
  layerId: string;
  layerName: string;
}
